var Klipsch = typeof Klipsch === "object" ? Klipsch : {}; Klipsch["zendeskWidget"] =
 (function(modules) { 
 	var installedModules = {};
 	function __webpack_require__(moduleId) {
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 		module.l = true;
 		return module.exports;
 	}
 	__webpack_require__.m = modules;
 	__webpack_require__.c = installedModules;
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
 	__webpack_require__.p = "";
 	return __webpack_require__(__webpack_require__.s = 116);
 })
 ({

 116:
 (function(module, exports) {



(() => {
  const loadZendeskChat = callback => {
    const zdscript = document.createElement('script');
    zdscript.setAttribute('id', 'ze-snippet');
    zdscript.src = 'https://static.zdassets.com/ekr/snippet.js?key=ff7dd7aa-ef81-4884-9ed1-666df204ec2b';
    document.getElementsByTagName('body')[0].appendChild(zdscript);
    window.zdonload = setInterval(() => {
      if (typeof zE !== 'undefined' && typeof zE.activate !== 'undefined') {
        clearInterval(window.zdonload);
        callback();
      }
    }, 50, null);
  };
  window.loadAndOpenZendeskChat = () => {
    const button = document.getElementById('zdbutton');
    localStorage.setItem('ff_zd_hasOpened', true);
    button.innerHTML = 'Loading...';
    loadZendeskChat(() => {
      window.setTimeout(() => {
        zE.activate();
        button.parentNode.removeChild(button);
      }, 1000);
    });
  };
  if (localStorage.getItem('ff_zd_hasOpened')) {
    loadZendeskChat(() => {});
  } else {
    document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', '<button class="help-button__placeholder" id="zdbutton" aria-label="Launch Help Chat Window" onClick="window.loadAndOpenZendeskChat();"><span class="help-button__chat-icon" type="Icon--chat"><svg class="help-button__chat-icon-img" id="Layer_1" x="0" y="0" viewBox="0 0 15 16" xml:space="preserve" aria-hidden="true"><title></title><path class="help-button__chat-icon-img-path" d="M1.3,16c-0.7,0-1.1-0.3-1.2-0.8c-0.3-0.8,0.5-1.3,0.8-1.5c0.6-0.4,0.9-0.7,1-1c0-0.2-0.1-0.4-0.3-0.7c0,0,0-0.1-0.1-0.1 C0.5,10.6,0,9,0,7.4C0,3.3,3.4,0,7.5,0C11.6,0,15,3.3,15,7.4s-3.4,7.4-7.5,7.4c-0.5,0-1-0.1-1.5-0.2C3.4,15.9,1.5,16,1.5,16 C1.4,16,1.4,16,1.3,16z M3.3,10.9c0.5,0.7,0.7,1.5,0.6,2.2c0,0.1-0.1,0.3-0.1,0.4c0.5-0.2,1-0.4,1.6-0.7c0.2-0.1,0.4-0.2,0.6-0.1 c0,0,0.1,0,0.1,0c0.4,0.1,0.9,0.2,1.4,0.2c3,0,5.5-2.4,5.5-5.4S10.5,2,7.5,2C4.5,2,2,4.4,2,7.4c0,1.2,0.4,2.4,1.2,3.3 C3.2,10.8,3.3,10.8,3.3,10.9z"></path></svg></span><span class="help-button__label">Help</span></button>');
  }
})();

 })

 });